export const getRouteInfo = (props) => {
  const { match, product } = props;
  const { params } = match || {};
  const { skuCode } = params || {};
  return { product, skuCode, match };
};
